import axios from 'axios'
import { currentCurrency } from '@/composables/currency'
import { currentLang } from '@/locales/lang'

axios.interceptors.request.use(config => {
  config.headers['Accept-Language'] = currentLang.value
  config.headers['X-Currency'] = currentCurrency.value
  return config
})

export default axios
